import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import "./index.css";
import "./components/SgcTooltip.css";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/ViewerHeader";
import SiteFooter from "./components/SiteFooter";
import SiteContentModal from "./components/siteContent/SiteContentModal";
import HomePage from "./features/pages/HomePage";
import VolcanDetail from "./features/pages/VolcanDetail";
import EventoDetalle from "./features/pages/EventoDetalle";
import CreditosPage from "./features/pages/CreditosPage";
import AcercaPage from "./features/pages/AcercaPage";
import AjustesPage from "./features/pages/AjustesPage";
import { MapSettingsProvider } from "./context/MapSettingsContext";

function App() {
  const [contentModal, setContentModal] = useState(null);

  return (
    <Router>
      <ScrollToTop />
      <MapSettingsProvider>
        <div className="ui-viewer-container">
          <Header onOpenContent={setContentModal} />
          <SiteContentModal
            type={contentModal}
            onClose={() => setContentModal(null)}
          />
          <main className="content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/creditos" element={<CreditosPage />} />
              <Route path="/acerca" element={<AcercaPage />} />
              <Route path="/ajustes" element={<AjustesPage />} />
              <Route path="/volcan-detalle" element={<VolcanDetail />} />
              <Route path="/evento-detalle" element={<EventoDetalle />} />
            </Routes>
          </main>
          <SiteFooter />
        </div>
      </MapSettingsProvider>
    </Router>
  );
}

export default App;
